export default "/images/vendor/flag-icon-css/flags/4x3/fm.svg?bc057f7505830fd69f4b2166e962a78f";